export {
  default,
  getServerSideProps,
} from "@/pages/dispensaries/[[...location]]";
